const STORAGE_KEYS = {
  BUSINESSES: 'mysterious_brothers_businesses',
  CUSTOMERS: 'mysterious_brothers_customers',
  CARDS: 'mysterious_brothers_cards',
  PAYMENTS: 'mysterious_brothers_payments',
  EXPENSES: 'mysterious_brothers_expenses',
  DAILY_RATES: 'mysterious_brothers_daily_rates',
  LAST_SYNC: 'mysterious_brothers_last_sync',
  SELECTED_BUSINESS: 'mysterious_brothers_selected_business',
};

export async function saveToStorage<T>(key: string, data: T): Promise<void> {
  try {
    const jsonValue = JSON.stringify(data);
    localStorage.setItem(key, jsonValue);
  } catch (error) {
    console.error(`Error saving ${key} to storage:`, error);
  }
}

export async function getFromStorage<T>(key: string): Promise<T | null> {
  try {
    const jsonValue = localStorage.getItem(key);
    return jsonValue != null ? JSON.parse(jsonValue) : null;
  } catch (error) {
    console.error(`Error reading ${key} from storage:`, error);
    return null;
  }
}

export async function removeFromStorage(key: string): Promise<void> {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(`Error removing ${key} from storage:`, error);
  }
}

export async function clearAllStorage(): Promise<void> {
  try {
    localStorage.clear();
  } catch (error) {
    console.error('Error clearing storage:', error);
  }
}

export async function saveBusinessData(businessId: string, data: any): Promise<void> {
  await saveToStorage(`${STORAGE_KEYS.BUSINESSES}_${businessId}`, data);
}

export async function getBusinessData(businessId: string): Promise<any> {
  return await getFromStorage(`${STORAGE_KEYS.BUSINESSES}_${businessId}`);
}

export async function setLastSyncTime(businessId: string): Promise<void> {
  await saveToStorage(`${STORAGE_KEYS.LAST_SYNC}_${businessId}`, new Date().toISOString());
}

export async function getLastSyncTime(businessId: string): Promise<string | null> {
  return await getFromStorage(`${STORAGE_KEYS.LAST_SYNC}_${businessId}`);
}

export async function setSelectedBusiness(businessId: string): Promise<void> {
  await saveToStorage(STORAGE_KEYS.SELECTED_BUSINESS, businessId);
}

export async function getSelectedBusiness(): Promise<string | null> {
  return await getFromStorage(STORAGE_KEYS.SELECTED_BUSINESS);
}

export async function clearSelectedBusiness(): Promise<void> {
  await removeFromStorage(STORAGE_KEYS.SELECTED_BUSINESS);
}

export { STORAGE_KEYS };
